import { Say } from "../../../languages";
import AlertMessage from "../../Shared/AlertMessage";

type Props = {
  visible: boolean;
};

export function AfterEventSignUpMessage({ visible = true }: Props) {
  /* TODO: Include Finalized messaging to user */

  if (visible === false) {
    return null;
  }

  return (
    <AlertMessage alertType="info">
      <Say phrase="chosen.thank_you.event_ended" />
    </AlertMessage>
  );
}

export default AfterEventSignUpMessage;
